import { render, staticRenderFns } from "./ControllerCategory.vue?vue&type=template&id=020dbfc3&scoped=true&"
import script from "./ControllerCategory.vue?vue&type=script&lang=js&"
export * from "./ControllerCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020dbfc3",
  null
  
)

export default component.exports